/**
 * 组件显示控制的配置盘点
 * -------------------
 * 要调用这个mixin，默认组件已经有个 
 * attrs、row、page这些属性
 */
export default {
    data () {
        return {
            displayLogic: null, // 显示控制逻辑函数
            watchDisplay: true // 监听页面数据变化，判断的显示
        }
    },
    watch: {
        page: {
            handler () {
                let bool = true
                // 是否有display的控制
                if (this.displayLogic) {
                    bool = this.displayLogic(this)
                }
                this.watchDisplay =  bool
            },
            deep: true
        }
    },  
    created () {
       this.initDispalyFunction()
    },
    computed: {
        /**
         * 组件是否显示的控制
         * ----- 
         * 这里不是随数据变化的
         */
        isDisplay () {
            let bool = true
            // 是否有display的控制
            if (this.displayLogic) {
                bool = this.displayLogic(this)
            }
            return bool
        }
    },
    methods: {
        /**
         * 将字符串中的{{name}}插值符号，专为对应字段中的值
         * @param str 要转化的字符
         * @param obj 用于取值的对象
         */
        templateString (str, obj) {
            let match = str.match(/{{([a-zA-Z_]*)}}/)
            if (match && match.length > 0) {
                let value = obj[match[1]]// 取得对应对象中的值
                // 将字符中对应的插值，替换
                str = str.replace(match[0], value)
                // 递归调用
                return this.templateString(str, obj)
            } else {
                return str
            }
        },
        initDispalyFunction () {
            // 初始化控制逻辑字符串
            if (this.attrs && this.attrs.display && this.attrs.display.length > 0) {
                // 逻辑判断的字符数组
                let logic = this.attrs.display.split('&&')
                let condition = [] // 存放逻辑判断条件的数组
                // 数据来源的设定逻辑字符
                // 根据ID的存在来判定，每个页面或行数据必然youID
                let dataStr = `
                    var data = {}
                    if (self.row && self.row['id']) {
                        data = self.row
                    } else {
                        data = self.page
                    };
                `
                logic.forEach((str) => {
                    // 获取用于判断的字段
                    let filed = str.match(/(\S*)(==|!=|:in|:notin)/)
                    if (filed && filed.length > 1) {
                        filed = filed[1]
                        // 用于判断的逻辑字符
                        let logicStr = str.replace(filed, '')
                        // 处理 in和 not in 的操作
                        if (logicStr.indexOf(':in') >= 0 || logicStr.indexOf(':notin') >= 0) { 
                            let str = logicStr.replace(':in', '').replace(':notin', '') + '.indexOf(' +  'data["' + filed + '"])' 
                            logicStr = logicStr.indexOf(':in') >= 0 ? '>=0' : '<0'
                            logicStr = str + logicStr
                        } else {
                            logicStr = 'data["' + filed + '"] ' + logicStr
                        }
                        condition.push('(' + logicStr + ')')
                    }
                })
                // 执行逻辑代码
                logic = condition.length > 0 ? condition.join('&&') : 'false'
                logic =  dataStr + ' return ' + logic
                this.displayLogic = new Function('self', logic)
            }
            
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/compDisplay.mixin.js